export default __webpack_public_path__ + "static/media/composition_white_24px.63f1b409.svg";